import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SlugResolver from './pages/templates/SlugResolver';
import ProcLinkTemplate from './pages/templates/ProcLinkTemplate';
import DeptLinkTemplate from './pages/templates/DeptLinkTemplate';
import HospitalLinkTemplate from './pages/templates/HospitalLinkTemplate';

function NotFound() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'sans-serif' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 48 }}>😕</div>
        <h2>Page not found</h2>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Direct routes */}
        <Route path="/d/:deptId" element={<DeptLinkTemplate />} />
        <Route path="/hospital" element={<HospitalLinkTemplate />} />

        {/* Slug-based route — auto-detects hospital/department/procedure */}
        <Route path="/slug/:slug" element={<SlugResolver />} />

        {/* Fallback */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}
